import React, { Component } from "react";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import { callApi } from "../../utils/api";
import QueryTrayReportTable from "./QueryTrayReportTable";

interface AllProps {
  match: any;
  history: any;
}

export default class QueryTraySubReport extends Component<AllProps> {
  state = {
    reports: [] as any[],
    status_id: "",
    type: "",
    reportTitle: "Query Tray Report",
    selectedFileIds: [] as number[],
    isMovingToProcess: false,
  };

  getReportTitle = (status: string) => {
    switch (String(status)) {
      case "30":
        return "Save In Query Tray";
      case "31":
        return "Pending In Query Tray";
      case "33":
        return "Query Received Move to Process";
      case "34":
        return "Query Received Files (Directly)";
      case "32":
        return "Partial Query Documents";
      default:
        return "Query Tray Report";
    }
  };

  canMoveToProcess = () => ["30", "31", "32"].includes(String(this.state.status_id));

  componentDidMount() {
    const status = this.props.match.params.id;
    const type = this.props.match.params.type;
    this.getQueryTraySubReport(status, type);
  }

  redirectToDashboard = (id: number) => {
    if (id !== undefined) {
      const status = this.state.status_id;
      const type = this.state.type;
      const url = `/query-tray-report/${type}/${status}`;
      localStorage.setItem("url", url);
      localStorage.setItem("thisPopup", JSON.stringify({ id }));
      localStorage.setItem("currentfileId", JSON.stringify(id));
      this.props.history.push("/file-dashboard/" + id);
    }
  };

  getQueryTraySubReport(status: string, type: string) {
    const { state } = this.props.history.location;
    const filterData = state && state.filterData;
    this.setState({
      status_id: status,
      type,
      reportTitle: this.getReportTitle(status),
      selectedFileIds: [],
    });

    let payload: any = { status, type };
    if (filterData) {
      payload = { ...payload, ...filterData };
    }

    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    payload = {
      ...payload,
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };

    callApi("POST", "query_tray_subreport.php", payload)
      .then((res) => res.data)
      .then((result) => {
        this.setState({
          reports: Array.isArray(result.data) ? result.data : [],
        });
      })
      .catch(() => {
        ToastsStore.error("Failed to load Query Tray subreport");
        this.setState({ reports: [] });
      });
  }

  toggleFileSelection = (fileId: number) => {
    if (!fileId) return;
    this.setState((prevState: any) => {
      const selected = new Set(prevState.selectedFileIds || []);
      if (selected.has(fileId)) selected.delete(fileId);
      else selected.add(fileId);
      return { selectedFileIds: Array.from(selected) };
    });
  };

  toggleAllFileSelection = (fileIds: number[]) => {
    const validIds = (fileIds || []).filter((id) => id > 0);
    const currentSelected = this.state.selectedFileIds || [];
    const allSelected =
      validIds.length > 0 && validIds.every((id) => currentSelected.includes(id));
    this.setState({ selectedFileIds: allSelected ? [] : validIds });
  };

  moveSelectedToProcess = async () => {
    const selectedFileIds = this.state.selectedFileIds || [];
    if (!selectedFileIds.length) {
      ToastsStore.warning("Select at least one file to move to process.");
      return;
    }

    const fileLabel =
      selectedFileIds.length === 1
        ? "the selected file"
        : `the ${selectedFileIds.length} selected files`;
    if (!window.confirm(`Are you sure you want to move ${fileLabel} to process?`)) {
      return;
    }

    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : null;
    const userId = userDetails ? userDetails.userId : null;
    if (!userId) {
      ToastsStore.error("Unable to identify the current user.");
      return;
    }

    this.setState({ isMovingToProcess: true });

    try {
      const response = await callApi("POST", "query_tray_move_to_process.php", {
        user_id: userId,
        file_ids: selectedFileIds,
        type: "process",
        apply_status: true,
      })
        .then((res) => res.data)
        .catch(() => ({ result: false, message: "Request failed" }));

      const successCount = Number(response?.success_count ?? (response?.result ? selectedFileIds.length : 0));
      const failedCount = Number(
        response?.failed_count ?? (response?.result ? 0 : selectedFileIds.length)
      );

      if (successCount > 0) {
        ToastsStore.success(
          `${successCount} file${successCount > 1 ? "s" : ""} moved to process successfully.`
        );
      }
      if (failedCount > 0) {
        ToastsStore.warning(
          response?.message ||
            `${failedCount} file${failedCount > 1 ? "s" : ""} could not be moved to process.`
        );
      }
      if (!successCount && !failedCount) {
        ToastsStore.warning(response?.message || "No files were moved to process.");
      }

      this.setState({ selectedFileIds: [] });
      this.getQueryTraySubReport(this.state.status_id, this.state.type);
    } finally {
      this.setState({ isMovingToProcess: false });
    }
  };

  render() {
    const { reports, reportTitle, selectedFileIds, isMovingToProcess } = this.state;

    return (
      <section className="policymain-container complaint-box">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <h4>
                            <b>{reportTitle}</b>
                            <button
                              className="btn btn-primary"
                              style={{ float: "right" }}
                              onClick={() => this.props.history.goBack()}
                            >
                              Back
                            </button>
                          </h4>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="dt-responsive table-responsive">
                              <QueryTrayReportTable
                                reports={reports}
                                redirectToDashboard={this.redirectToDashboard}
                                showMoveToProcess={this.canMoveToProcess()}
                                selectedFileIds={selectedFileIds}
                                isMovingToProcess={isMovingToProcess}
                                onToggleFile={this.toggleFileSelection}
                                onToggleAll={this.toggleAllFileSelection}
                                onMoveToProcess={this.moveSelectedToProcess}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
